import { css as _css } from "@emotion/core";
var _excluded = ["media"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React, { useState, useEffect, createRef } from 'react';
import PropTypes from 'prop-types';
import { withMedia } from 'react-media-query-hoc';
import smoothscroll from 'smoothscroll-polyfill';
import { storageFactory } from '@domain-group/fe-helper';
import { ChevronLeftIcon, ChevronRightIcon, CloseIcon } from '@domain-group/fe-co-icon';
import SingleCard from './single-card';
import ScrollDrag, { SCROLL_EFFECT_DELAY } from './scroll-drag';
var OnboardingImage = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-property-history/static/car_e5da9933.svg";
import * as styles from './slider.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ONBOARDING_STORAGE_KEY = 'property-history-onboarding-closed';
var PropertyHistorySlider = _ref => {
  var media = _ref.media,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(props.isOnMarket ? 0 : props.cards.length),
    _useState2 = _slicedToArray(_useState, 2),
    expandedCount = _useState2[0],
    setExpandedCount = _useState2[1];
  var _useState3 = useState(!props.isOnMarket),
    _useState4 = _slicedToArray(_useState3, 2),
    expandAll = _useState4[0],
    setExpandAll = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    currentScrollVal = _useState6[0],
    setCurrentScrollVal = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isScrolling = _useState8[0],
    setIsScrolling = _useState8[1];
  var _useState9 = useState(props.cards.length > 1),
    _useState10 = _slicedToArray(_useState9, 2),
    showRightChevron = _useState10[0],
    setShowRightChevron = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showLeftChevron = _useState12[0],
    setShowLeftChevron = _useState12[1];
  var _useState13 = useState(props.showOnboarding),
    _useState14 = _slicedToArray(_useState13, 2),
    showOnboarding = _useState14[0],
    setShowOnboarding = _useState14[1];
  var _useState15 = useState(props.expandedIndices),
    _useState16 = _slicedToArray(_useState15, 2),
    expandedIndices = _useState16[0],
    setExpandedIndices = _useState16[1];
  var _useState17 = useState(true),
    _useState18 = _slicedToArray(_useState17, 2),
    dragEnabled = _useState18[0],
    setDragEnabled = _useState18[1];
  var scrollContainer = /*#__PURE__*/createRef();

  // this array keep track of all the Ref for the rendered cards
  // to use later to expand/collapse when we need to.
  var allCardsRef = props.cards.map(() => /*#__PURE__*/createRef());

  // Start polyfill for scrolling. This is especially needed for iOS
  // see AH-5342 for details
  useEffect(() => {
    smoothscroll.polyfill();
  }, []);

  // side effect to show/hide right chevron based on media and number of cards
  useEffect(() => {
    if (props.cards.length === 1) {
      setShowRightChevron(false);
    } else if (media.mobile && props.cards.length > 1) {
      // mobile always has chevron for multiple cards
      setShowRightChevron(true);
    } else if (!props.isOnMarket && props.cards.length > 2) {
      // tablet & desktop have more than 2 cards visible for off-market
      setShowRightChevron(true);
    } else if (props.isOnMarket && props.cards.length >= 3) {
      // tablet & desktop have 3 cards visible in live listing
      setShowRightChevron(true);
    } else {
      setShowRightChevron(false);
    }
    var MAX_DESKTOP_SCROLL = props.isOnMarket ? 1090 : 760;
    var MAX_TABLET_SCROLL = props.isOnMarket ? 800 : 480;
    if (media.desktop && scrollContainer.current.scrollWidth - currentScrollVal <= MAX_DESKTOP_SCROLL) {
      // we have reached to the end, hide right chevron
      setShowRightChevron(false);
    } else if (media.tablet && scrollContainer.current.scrollWidth - currentScrollVal <= MAX_TABLET_SCROLL) {
      // we have reached to the end, hide right chevron
      setShowRightChevron(false);
    } else if (media.mobile && scrollContainer.current.scrollWidth - window.innerWidth - currentScrollVal <= 150) {
      // we have reached to the end, hide right chevron
      setShowRightChevron(false);
    }
  }, [media, props.cards.length, props.isOnMarket, currentScrollVal, scrollContainer]);

  // side effect to show/hide left chevron and fade container
  useEffect(() => {
    // for mobile we hide chevron when it's <= 150
    if ((media.mobile && currentScrollVal > 150 ||
    // otherwise <= 10
    (media.desktop || media.tablet) && currentScrollVal > 10) && props.cards.length > 1) {
      setShowLeftChevron(true);
    } else {
      setShowLeftChevron(false);
    }
  }, [media, currentScrollVal, props.cards.length]);

  // side-effect to determine whether dragging / scrolling the slider is enabled
  useEffect(() => {
    setDragEnabled(media.tablet || media.desktop && props.cards.length > 2);
  }, [media, props.cards.length]);

  // side effect for onboarding local storage
  useEffect(() => {
    var storage = storageFactory({
      name: 'listing',
      driver: storageFactory.LOCALSTORAGE
    });
    setShowOnboarding(props.showOnboarding && !storage.getItem(ONBOARDING_STORAGE_KEY));
  }, [props.showOnboarding]);

  // side effect to expand cards on the fly
  useEffect(() => {
    setExpandedIndices(props.expandedIndices);
  }, [props.expandedIndices]);
  return ___EmotionJSX("div", {
    css: styles.sliderContainer
  }, (media.desktop || media.tablet) && showOnboarding && ___EmotionJSX("div", {
    css: styles.onboardingMessage
  }, "You don't need a time machine, we've built one for you. Research this property's past sales on the timeline below."), media.mobile && showOnboarding && ___EmotionJSX("div", {
    css: styles.onboardingMessageMobile
  }, "Now you can go waaay back! Research this property's past sales on the timeline below.", ___EmotionJSX("button", {
    css: styles.onboardingMessageClose,
    onClick: () => {
      var storage = storageFactory({
        name: 'listing',
        driver: storageFactory.LOCALSTORAGE
      });
      storage.setItem(ONBOARDING_STORAGE_KEY, true);
      setShowOnboarding(false);
    },
    type: "button",
    "aria-label": "Close"
  }, ___EmotionJSX(CloseIcon, {
    size: "small"
  }))), ___EmotionJSX("div", {
    css: styles.cardContainer
  }, showLeftChevron && ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([styles.fadeContainer, styles.fadeContainerLeft])
  }), ___EmotionJSX(ScrollDrag, {
    css: styles.slider,
    ref: scrollContainer,
    dragEnabled: dragEnabled,
    onSwipeLeft: props.onSwipeLeft,
    onSwipeRight: props.onSwipeRight,
    onScrollFinished: isDirectionLeft => {
      if (scrollContainer.current) {
        if (media.tablet) {
          // we have a weird bug on tablet (ipad in particular) where
          // scrolling does not register current scroll value
          // so we manually scroll further by 1 pixel to enforce it.
          scrollContainer.current.scrollBy({
            top: 0,
            left: isDirectionLeft ? -1 : 1,
            behavior: 'smooth'
          });
        }
        setCurrentScrollVal(scrollContainer.current.scrollLeft);
      }
      setIsScrolling(false);
    },
    onScrollStarted: () => {
      setIsScrolling(true);
    }
  }, (media.desktop || media.tablet) && props.isOnMarket && ___EmotionJSX("div", {
    css: styles.onboardingCard
  }, ___EmotionJSX("img", {
    src: OnboardingImage,
    alt: "Property History"
  })), props.cards.map((card, idx) => ___EmotionJSX(SingleCard, _extends({}, card, {
    css: styles.slide,
    key: card.date,
    ref: allCardsRef[idx],
    isExpanded: !props.isOnMarket && !media.mobile || expandAll || expandedIndices.indexOf(idx) > -1,
    disableExpand: isScrolling,
    onExpand: () => {
      if (media.mobile) {
        // on mobile one controls all others as per design
        setExpandAll(true);
        setExpandedCount(props.cards.length);
      } else {
        setExpandedCount(expandedCount + 1);
      }
      props.onExpand(card.id);
    },
    onCollapse: () => {
      if (media.mobile) {
        // on mobile one controls all others as per design
        setExpandAll(false);
        setExpandedCount(0);
      } else {
        setExpandedCount(expandedCount - 1);
      }
      props.onCollapse(card.id);
    },
    onPhotoClick: props.onPhotoClick
  }))), (media.tablet || media.desktop) && ___EmotionJSX("div", {
    css: styles.emptyCard
  })), showRightChevron && ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([styles.fadeContainer, styles.fadeContainerRight])
  }), showLeftChevron && ___EmotionJSX("button", {
    css: styles.navButtons,
    onClick: () => {
      props.onTapLeftChevron();
      scrollContainer.current.scrollBy({
        top: 0,
        left: -(media.mobile && expandAll ? window.screen.width - 9 : 240),
        behavior: 'smooth'
      });
      window.setTimeout(() => {
        setCurrentScrollVal(scrollContainer.current.scrollLeft);
      }, SCROLL_EFFECT_DELAY);
    },
    type: "button",
    "aria-label": "Left"
  }, ___EmotionJSX(ChevronLeftIcon, {
    css: styles.navButtonIcon,
    size: "custom"
  })), showRightChevron && ___EmotionJSX("button", {
    css: /*#__PURE__*/_css([styles.navButtons, styles.navRight]),
    onClick: () => {
      props.onTapRightChevron();
      scrollContainer.current.scrollBy({
        top: 0,
        left: media.mobile && expandAll ? window.screen.width - 9 : 240,
        behavior: 'smooth'
      });
      window.setTimeout(() => {
        setCurrentScrollVal(scrollContainer.current.scrollLeft);
      }, SCROLL_EFFECT_DELAY);
    },
    type: "button",
    "aria-label": "Right"
  }, ___EmotionJSX(ChevronRightIcon, {
    css: styles.navButtonIcon,
    size: "custom"
  }))));
};
PropertyHistorySlider.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.shape(SingleCard.propTypes)),
  media: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  isOnMarket: PropTypes.bool,
  showOnboarding: PropTypes.bool,
  onSwipeLeft: PropTypes.func,
  onSwipeRight: PropTypes.func,
  onTapRightChevron: PropTypes.func,
  onTapLeftChevron: PropTypes.func,
  onExpand: PropTypes.func,
  onCollapse: PropTypes.func,
  onPhotoClick: PropTypes.func,
  expandedIndices: PropTypes.arrayOf(PropTypes.number)
};
PropertyHistorySlider.defaultProps = {
  cards: [],
  media: {},
  isOnMarket: false,
  showOnboarding: true,
  onSwipeLeft: () => {},
  onSwipeRight: () => {},
  onTapRightChevron: () => {},
  onTapLeftChevron: () => {},
  onExpand: () => {},
  onCollapse: () => {},
  onPhotoClick: () => {},
  expandedIndices: []
};
export default withMedia(PropertyHistorySlider);